// extracted by mini-css-extract-plugin
export var imageWrapper = "join-to-facebook-group-module--image-wrapper--AZa1d";
export var wrapper = "join-to-facebook-group-module--wrapper--9474j";